import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import SectionTitle from '../project-manage/SectionTitle';
import Invitation from './Invitation';

export default function InvitationsNo(props) {
  const { event, onViewMessages } = props;

  const invitations = useConnect('invitation.find', {
    where: {
      eager: {
        $where: {
          eventId: event.id,
          response: 'No'
        }
      }
    },
    pagination: {
      pageSize: 100
    }
  });

  if (invitations.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  if (invitations.data.length === 0) {
    return null;
  }

  return (
    <SectionTitle
      title="Declined Partners"
      subtitle="These partners were unable to participate in the event."
    >
      <div className="grid grid-cols-1 gap-4">
        {invitations.data.map(function (invitation, index) {
          return (
            <Invitation
              key={invitation.id || invitation.cid}
              invitation={invitation}
              onViewMessages={onViewMessages}
            />
          );
        })}
      </div>
    </SectionTitle>
  );
};
